import styled from "@emotion/styled"
import { Grid } from "@mui/material"

const MainWrapper = styled.div`
position:relative;
padding: ${(props) => (props.p ? props.p : "0")};
margin: ${(props) => (props.m ? props.m : "0")};
text-align: ${(props) => (props.align ? props.align : "center")};

  @media screen and (max-width: 899px) {
    padding: ${(props) => (props.p799 ? props.p799 : "")};
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.p599 ? props.p599 : "30px 0")};
  }
`
const MainGrid = styled(Grid)`
padding: 30px 0 0;
@media screen and (max-width:899px){
  padding:20px;
}
`
const Tokenimg = styled.img`
  width:100%;
  height:auto;
  max-width: 700px;
  position:absolute;
  bottom:-80px;
  @media screen and (max-width:1440px){
    max-width: 600px; 
  }
  @media screen and (max-width:899px){
    position:unset; 
}
`
const GridsWrap = styled(Grid)`
text-align:left;
@media screen and (max-width:899px){
  padding:20px;
}
`
const GridsRead = styled(Grid)`
text-align:start;
display:flex;
align-items:end;
@media screen and (max-width:899px){
  padding:40px 0 0px;
}
`
export{MainWrapper,MainGrid,Tokenimg,GridsWrap,GridsRead}